<template>
  <div class="w-full" :class="heightAuto ? '' : 'h-16'">
    <VField
      :name="name"
      v-slot="{ field, errors }"
      class="mb-3 w-full"
      v-model="localValue"
    >
      <div class="relative flex h-10 w-full">
        <select
          v-bind="field"
          class="w-full rounded-md px-4 py-2 h-11 appearance-none"
          :class="[
            classes,
            errors[0]
              ? 'border border-red-500'
              : hasBorder
              ? 'border border-gray-400'
              : '',
          ]"
          @focus="isOpen = true"
          @blur="isOpen = false"
          @change="handleChange"
        >
          <option
            v-for="option in options"
            :key="option.value"
            :selected="option.isSelected"
            :value="option.value"
            class="!text-blue-700"
          >
            {{ option.text }}
          </option>
        </select>
        <div
          class="h-full aspect-square absolute end-0 rounded-e-lg flex justify-center items-center text-blue-700 stroke-blue-700"
        >
          <IconArrowDown :class="isOpen ? 'rotate-180 ' : ''" />
        </div>
        <span
          v-if="require"
          class="!absolute left-1 p-2 font-bold text-red-500 mx-2"
        >
          *
        </span>
      </div>
      <div
        v-if="errors.length"
        class="text-red-500 text-xs mt-1 ms-1 mb-1 font-bold"
      >
        <p v-text="errors[0]" class="font-12" />
      </div>
    </VField>
  </div>
</template>

<script>
import { Field } from "vee-validate";

export default {
  components: {
    VField: Field,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    classes: {
      type: String,
      required: false,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: "2xl",
      validate: () => "lg" || "2xl" || "full",
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasBorder: {
      type: Boolean,
      required: false,
      default: false,
    },
    require: {
      type: Boolean,
      required: false,
      default: false,
    },
    heightAuto: {
      type: Boolean,
    },
    modelValue: {
      type: String,
      default: "",
    },
    // onChange: {
    //   type: Function,
    //   default: ()=>{}
    // },
  },
  setup(props, { emit }) {
    const isOpen = ref(false);
    const localValue = ref(props.modelValue);
    const handleChange = (event) => {
      // props.onChange(event);
      isOpen.value = false;
      localValue.value = event.target.value;
      emit("update:modelValue", event.target.value);
    };
    watch(
      () => props.modelValue,
      (newValue) => {
        localValue.value = newValue;
      }
    );
    return {
      isOpen,
      localValue,
      handleChange,
    };
  },
};
</script>
